<script lang="ts">
    
    import type { SecretActivity } from "../../Model/SecretActivity";
    import ActiviyModal from "../Shared/ActiviyModal.svelte";
    import Button from "../Shared/Button.svelte";
    import InputText from "../Shared/InputText.svelte";
    import { createEventDispatcher, getContext } from "svelte";
    import type { SaveGame } from "../../global";
    import WinScreen from "../Shared/WinScreen.svelte";
    import FailScreen from "../Shared/FailScreen.svelte";

    export let activity: SecretActivity;

    const saveGame: SaveGame = getContext('saveGame');
    const dispatch = createEventDispatcher();

    let answer = '';
    let showWinScreen = false;
    let showFailScreen = false;
    let points = 0;

    async function onCheck(): Promise<void> {
        if (!answer) {
            return;
        }
        if (activity.checkAnswer(answer)) {
            points = activity.isCompleted.value ? 0 : activity.points.win;
            showWinScreen = true;
            setCompletedIfRequired();
        } else {
            points = activity.points.fail;
            showFailScreen = true;
        }
    }

    function setCompletedIfRequired(): void {
        if (activity.isCompleted.value) {
            return;
        }
        activity.setCompleted();
        saveGame();
    }

    function onWinContinue(): void {
        dispatch('close');
    }

    function onFailContinue(): void {
        answer = '';
        showFailScreen = false;
    }

</script>

<ActiviyModal on:close title={activity.title} flex>
    <div class="image">
        <img src={activity.image} alt="">
    </div>
    <div class="statement">
        {activity.statement}
    </div>
    <div class="answer">
        <div class="form">
            <InputText bind:value={answer} grow />
            <Button color="aux" on:click={onCheck}>Send</Button>
        </div>
    </div>
</ActiviyModal>

{#if showWinScreen}
    <WinScreen {points} on:continue={onWinContinue} />
{/if}

{#if showFailScreen}
    <FailScreen {points} on:continue={onFailContinue} />
{/if}

<style lang="scss">

    @use 'sass:math';

    .image {
        flex: 3 0 0;
        min-height: 0;
        background-color: #222;

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .statement {
        flex: 1 0 0;
        padding: 15px;
    }

    .answer {
        overflow: hidden;
        flex: 1 0 0;
        background-color: var(--color-secondary);
    }

    .form {
        width: 100%;
        height: 100%;
        padding: 15px;
        display: flex;
        align-items: center;
        gap: 5px;
        box-sizing: border-box;
    }

</style>

